/*
 * Chappy 自作ウィッシュリスト
 * - ゲスト: localStorage の KEY に保存。中身は [{ id, handle, added }]（新しい順）
 * - ログイン中: 顧客メタフィールド chappy.wishlist に保存。
 *   初期値は layout/theme.liquid が window.ChappyWishlistCustomer = { id, items } として埋め込む。
 *   変更はアプリプロキシ /apps/chappy-wishlist（Cloudflare Worker、wishlist-worker/）へ送る。
 *   送信前の操作は ACCOUNT_KEY の pending に控え、失敗しても次の操作・次のページ表示で再送する。
 *   ログインした時点でゲストのお気に入りがあれば、アカウントへ移してゲスト側は空にする。
 * - [data-chappy-wl="商品ID"] のボタンを押すと追加/削除
 * - [data-chappy-wl-count] に件数を表示（0件なら非表示）
 * - [data-chappy-wl-page] があるページでは一覧を描画（/products/{handle}.js から価格・画像・在庫を取得）
 */
(function () {
  var KEY = 'chappy-wishlist-v1';
  var ACCOUNT_KEY = 'chappy-wishlist-account';
  var LEGACY_KEY = 'st-wishlist-local'; // SWishlist のゲスト用保存先
  var IMPORTED_KEY = 'chappy-wishlist-imported';
  var PROXY_URL = '/apps/chappy-wishlist';

  var customer = window.ChappyWishlistCustomer || null;
  var account = null; // ログイン中のみ { customerId, server: [...], pending: [...] }

  function loadJson(key, fallback) {
    try {
      var value = JSON.parse(localStorage.getItem(key));
      return value == null ? fallback : value;
    } catch (e) {
      return fallback;
    }
  }

  function saveJson(key, value) {
    try {
      localStorage.setItem(key, JSON.stringify(value));
    } catch (e) {}
  }

  function indexOf(list, id) {
    for (var i = 0; i < list.length; i++) {
      if (String(list[i].id) === String(id)) return i;
    }
    return -1;
  }

  function applyOps(items, ops) {
    var list = items.slice();
    ops.forEach(function (op) {
      var i = indexOf(list, op.id);
      if (op.action === 'remove' && i >= 0) list.splice(i, 1);
      if (op.action === 'add' && i < 0) list.unshift({ id: String(op.id), handle: op.handle, added: op.added });
    });
    list.sort(function (a, b) {
      return (b.added || 0) - (a.added || 0);
    });
    return list;
  }

  function readGuest() {
    var list = loadJson(KEY, []);
    return Array.isArray(list) ? list : [];
  }

  function read() {
    return account ? applyOps(account.server, account.pending) : readGuest();
  }

  function toggle(id, handle) {
    var on = indexOf(read(), id) >= 0;
    var op = on
      ? { action: 'remove', id: String(id) }
      : { action: 'add', id: String(id), handle: handle, added: Date.now() };

    if (account) {
      account.pending.push(op);
      saveJson(ACCOUNT_KEY, account);
      refresh();
      flush();
    } else {
      saveJson(KEY, applyOps(readGuest(), [op]));
      refresh();
    }
  }

  // ---------------------------------------------------------------- ログイン中の同期
  var flushing = false;

  function flush() {
    if (!account || flushing || account.pending.length === 0) return;
    flushing = true;
    var sending = account.pending.slice();
    fetch(PROXY_URL, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify({ ops: sending }),
    })
      .then(function (res) {
        if (!res.ok) throw new Error('wishlist sync failed: ' + res.status);
        return res.json();
      })
      .then(function (data) {
        account.server = Array.isArray(data.items) ? data.items : account.server;
        account.pending = account.pending.slice(sending.length);
        saveJson(ACCOUNT_KEY, account);
        flushing = false;
        refresh();
        flush(); // 送信中に増えた操作
      })
      .catch(function () {
        // 通信できなかった操作は pending に残り、次の操作・次のページ表示で再送される
        flushing = false;
      });
  }

  function initAccount() {
    if (!customer || customer.id == null) return;
    var customerId = String(customer.id);
    var cached = loadJson(ACCOUNT_KEY, null);
    var pending = cached && cached.customerId === customerId && Array.isArray(cached.pending) ? cached.pending : [];

    // ゲストのときに追加していたものをアカウントへ移す
    readGuest().forEach(function (item) {
      pending.push({ action: 'add', id: String(item.id), handle: item.handle, added: item.added || Date.now() });
    });
    saveJson(KEY, []);

    account = {
      customerId: customerId,
      server: Array.isArray(customer.items) ? customer.items : [],
      pending: pending,
    };
    saveJson(ACCOUNT_KEY, account);
    flush();
  }

  // SWishlist でゲストが保存していたものを一度だけ取り込む（handle が分かるものだけ）
  function importLegacy() {
    try {
      if (localStorage.getItem(IMPORTED_KEY)) return;
      var legacy = JSON.parse(localStorage.getItem(LEGACY_KEY) || '[]');
      var list = readGuest();
      if (Array.isArray(legacy)) {
        legacy.forEach(function (item) {
          if (item && item.id && item.handle && indexOf(list, item.id) < 0) {
            list.push({ id: String(item.id), handle: item.handle, added: Date.parse(item.addedDate) || Date.now() });
          }
        });
      }
      localStorage.setItem(KEY, JSON.stringify(list));
      localStorage.setItem(IMPORTED_KEY, '1');
    } catch (e) {}
  }

  function paintButtons() {
    var ids = {};
    var list = read();
    list.forEach(function (item) {
      ids[String(item.id)] = true;
    });
    document.querySelectorAll('[data-chappy-wl]').forEach(function (button) {
      var on = !!ids[button.getAttribute('data-chappy-wl')];
      button.classList.toggle('is-active', on);
      button.setAttribute('aria-pressed', on ? 'true' : 'false');
      button.setAttribute('aria-label', on ? 'お気に入りから外す' : 'お気に入りに追加');
      var label = button.querySelector('[data-chappy-wl-label]');
      if (label) label.textContent = on ? 'お気に入りに追加済み' : 'お気に入りに追加';
    });
    document.querySelectorAll('[data-chappy-wl-count]').forEach(function (el) {
      el.textContent = list.length;
      el.hidden = list.length === 0;
    });
  }

  // ---------------------------------------------------------------- 一覧ページ
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var productCache = {};

  function fetchProduct(handle) {
    if (!productCache[handle]) {
      productCache[handle] = fetch(root + 'products/' + encodeURIComponent(handle) + '.js').then(function (res) {
        return res.ok ? res.json() : null;
      }).catch(function () {
        return null;
      });
    }
    return productCache[handle];
  }

  function formatPrice(cents) {
    return '¥' + Math.round(cents / 100).toLocaleString('ja-JP');
  }

  function el(tag, className, text) {
    var node = document.createElement(tag);
    if (className) node.className = className;
    if (text != null) node.textContent = text;
    return node;
  }

  function heartButton(id, handle) {
    var button = el('button', 'chappy-wl-btn chappy-wl-btn--card');
    button.type = 'button';
    button.setAttribute('data-chappy-wl', id);
    button.setAttribute('data-handle', handle);
    button.innerHTML =
      '<svg class="chappy-wl-heart" viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M12 20.6s-7.6-4.6-9.3-9.4C1.6 8 3.4 4.6 6.9 4.3c2-.2 3.7.9 5.1 2.7 1.4-1.8 3.1-2.9 5.1-2.7 3.5.3 5.3 3.7 4.2 6.9-1.7 4.8-9.3 9.4-9.3 9.4z"/></svg>';
    return button;
  }

  function buildItem(entry, product) {
    var li = el('li', 'chappy-wl-item' + (product && !product.available ? ' is-sold-out' : ''));
    var media = el('div', 'chappy-wl-item__media');
    var info = el('div', 'chappy-wl-item__info');

    if (product) {
      var url = root + 'products/' + product.handle;
      var link = el('a', 'chappy-wl-item__link');
      link.href = url;
      if (product.featured_image) {
        var img = el('img');
        var src = product.featured_image.indexOf('//') === 0 ? 'https:' + product.featured_image : product.featured_image;
        img.src = src + (src.indexOf('?') >= 0 ? '&' : '?') + 'width=533';
        img.alt = product.title;
        img.loading = 'lazy';
        img.width = 533;
        img.height = 533;
        link.appendChild(img);
      }
      media.appendChild(link);
      if (!product.available) {
        var badgeTemplate = document.querySelector('[data-chappy-wl-badge]');
        if (badgeTemplate) media.appendChild(badgeTemplate.content.cloneNode(true));
        else media.appendChild(el('span', 'chappy-wl-item__badge', '売り切れ'));
      }

      var title = el('a', 'chappy-wl-item__title', product.title);
      title.href = url;
      info.appendChild(title);
      info.appendChild(el('p', 'chappy-wl-item__price', formatPrice(product.price)));
    } else {
      media.appendChild(el('div', 'chappy-wl-item__placeholder'));
      info.appendChild(el('p', 'chappy-wl-item__title', 'この商品は販売を終了しました'));
    }

    media.appendChild(heartButton(entry.id, entry.handle));
    li.appendChild(media);
    li.appendChild(info);
    return li;
  }

  var pageRenderId = 0;

  function renderPage() {
    var container = document.querySelector('[data-chappy-wl-page]');
    if (!container) return;
    var list = read();
    var grid = container.querySelector('[data-chappy-wl-grid]');
    var empty = container.querySelector('[data-chappy-wl-empty]');
    var summary = container.querySelector('[data-chappy-wl-summary]');

    empty.hidden = list.length > 0;
    summary.hidden = list.length === 0;
    if (list.length === 0) {
      grid.innerHTML = '';
      return;
    }

    var renderId = ++pageRenderId;
    Promise.all(list.map(function (entry) {
      return entry.handle ? fetchProduct(entry.handle) : Promise.resolve(null);
    })).then(function (products) {
      if (renderId !== pageRenderId) return; // より新しい描画が始まっている
      var fragment = document.createDocumentFragment();
      var available = 0;
      list.forEach(function (entry, i) {
        if (products[i] && products[i].available) available++;
        fragment.appendChild(buildItem(entry, products[i]));
      });
      grid.innerHTML = '';
      grid.appendChild(fragment);
      summary.textContent = list.length + '点（うち販売中 ' + available + '点）';
      paintButtons();
    });
  }

  function refresh() {
    paintButtons();
    renderPage();
  }

  // ---------------------------------------------------------------- イベント
  document.addEventListener('click', function (event) {
    var button = event.target.closest && event.target.closest('[data-chappy-wl]');
    if (!button) return;
    event.preventDefault();
    event.stopPropagation();
    toggle(button.getAttribute('data-chappy-wl'), button.getAttribute('data-handle'));
  });

  // 別タブで変更されたとき
  window.addEventListener('storage', function (event) {
    if (event.key === KEY) refresh();
    if (event.key === ACCOUNT_KEY && account) {
      var latest = loadJson(ACCOUNT_KEY, null);
      if (latest && latest.customerId === account.customerId) {
        account.server = latest.server || account.server;
        account.pending = latest.pending || [];
        refresh();
      }
    }
  });

  // 絞り込み・ページ送り・クイック追加などで商品カードが差し替わったとき
  var scheduled = false;
  new MutationObserver(function (mutations) {
    if (scheduled) return;
    for (var i = 0; i < mutations.length; i++) {
      var added = mutations[i].addedNodes;
      for (var j = 0; j < added.length; j++) {
        var node = added[j];
        if (node.nodeType === 1 && (node.matches('[data-chappy-wl]') || node.querySelector('[data-chappy-wl]'))) {
          scheduled = true;
          requestAnimationFrame(function () {
            scheduled = false;
            paintButtons();
          });
          return;
        }
      }
    }
  }).observe(document.documentElement, { childList: true, subtree: true });

  importLegacy();
  initAccount();
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', refresh);
  else refresh();
})();
